import {
  IonButtons,
  IonContent,
  IonHeader,
  IonMenuButton,
  IonPage,
  IonTitle,
  IonToolbar,
  IonGrid,
  IonRow,
  IonCol,
  IonItemDivider,
  withIonLifeCycle,
  IonLabel,
  useIonViewDidEnter,
} from "@ionic/react";
import { useParams } from "react-router";
import ExploreContainer from "../components/ExploreContainer";
import { Descriptions, Row, Col } from "antd";
import { Card } from "antd";
import { Switch } from "antd";
import { Input } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import moment from "moment";
import { menuController } from "@ionic/core";
import {
  DatePicker,
  Space,
  Button,
  Select,
  AutoComplete,
  Cascader,
} from "antd";
import { UIStore } from "../store/store";
import { checklogin, setlogin } from "../store/actions";

import { useEffect, useState } from "react";
import { Avatar } from "antd";

import { message } from "antd";
import logo from "./images/logo.png";
import { AntDesignOutlined } from "@ant-design/icons";
import axios from "axios";
import { apiConfig } from "../config/api.config";


const Login: React.FC = (props: any) => {


  function onChange(unchecked: any) {
    // Switch state changed
  }



  async function FetchLogin() {

    if (ApplicationObject.Email.length < 1) {
      message.error("Username Required");
    }

    if (ApplicationObject.Password.length < 1) {
      message.error("Password Required");
    }

    try {
      axios({
        method: "post",
        url: apiConfig.endpoints.auth.adminLogin,
        data: ApplicationObject,
      })
        .then(function (response) {
          // Login response received
          if(response.data.status === true){
            message.success("Login Success");
            setlogin(true);
            UIStore.update((s: { isLoggedIn: boolean }) => {
              s.isLoggedIn = !s.isLoggedIn;
            });
            window.location.href = "/";

          }
          if(response.data.status !== true){

            setlogin(false);
            message.error("Incorrect Credentials");
          }

     
  

 
        })
        .catch(function (response) {
          //handle error
          message.error("Incorrect Credentials");
          // Error handled
        });
    } catch (error) {
      message.error("Incorrect Credentials");
      // Error handled
    }
  }

  useIonViewDidEnter(() => {
    
  });







  const [ApplicationObject, setState] = useState({
    Email: "",
    Password: "",
  });

  const handleChange = (e: { target: { name: any; value: any } }) => {
    const { name, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  return (
    <IonPage>
      <IonContent fullscreen>
        <IonRow style={{ marginTop: "10%", marginLeft: "25%" }}>
          <IonCol>
            <div></div>
          </IonCol>
          <IonCol></IonCol>
          <IonCol>
            <Card style={{ width: 500 }}>
              <IonRow>
                <IonCol>
                  <div></div>
                </IonCol>

                <IonCol>
                  <img src={logo} alt="logo" />
                </IonCol>

                <IonCol>
                  <div></div>
                </IonCol>
              </IonRow>
              <IonRow>
                <Input
                  size="large"
                  value={ApplicationObject.Email}
                  type="email"
                  onChange={handleChange}
                  name="Email"
                  placeholder="Email"
                  prefix={<UserOutlined />}
                />

                <br />
                <br />
                <Input
                  size="large"
                  value={ApplicationObject.Password}
                  type="password"
                  onChange={handleChange}
                  name="Password"
                  placeholder="Password"
                  prefix={<LockOutlined />}
                />

                <br />
              </IonRow>
              <IonRow>
                <IonCol></IonCol>
                <IonCol></IonCol>
                <IonCol></IonCol>
                <IonCol style={{ marginTop: "20px" }}>
                  <Button
                    onClick={() => {
                      FetchLogin();
                    }}
                    block
                    type="primary"
                  >
                    Login
                  </Button>
                </IonCol>
                <IonCol></IonCol>
                <IonCol></IonCol>
                <IonCol></IonCol>
              </IonRow>
              <IonRow>
                <IonCol></IonCol>
                <IonCol></IonCol>
                <IonCol></IonCol>
                <IonCol>
                  {/* <Button href="/RegistrationPage" block type="primary">Register</Button> */}
                </IonCol>
                <IonCol></IonCol>
                <IonCol></IonCol>
                <IonCol></IonCol>
              </IonRow>
            </Card>
          </IonCol>
          <IonCol>
            <div></div>
          </IonCol>
          <IonCol>
            <div></div>
          </IonCol>
          <IonCol>
            <div></div>
          </IonCol>
          <IonCol>
            <div></div>
          </IonCol>
          <IonCol>
            <div></div>
          </IonCol>
          <IonCol>
            <div></div>
          </IonCol>
        </IonRow>
      </IonContent>
    </IonPage>
  );
};

export default Login;
